module.exports = __webpack_public_path__ + "img/tiktok-icon.447c4f36.png";